class BESSAppProjectDetailsEditorManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
        this.siteTypeChanged = false;
        this.projectInputs = editor.items[0].inputs;
        editor.projectInputs = editor.items[0].inputs;
        this.locationManager = new BESSAppProjectDetailsEditorLocationManager(editor);
        this.siteTypeManager = new BESSAppProjectDetailsEditorSiteTypeManager(editor, this);
    }

    saved(result) {
        if(this.siteTypeChanged) {
            window.location.reload();
            return;
        }
        $.get(window.location.href, function (results) {

            let oldProjectDetails = $('.app-reload-on-project-details-update');
            let newProjectDetails = $(results).find('.app-reload-on-project-details-update');

            oldProjectDetails.replaceWith(newProjectDetails);
            BESSAppComponent.initialiseFor($('.app-reload-on-project-details-update'));

            BESSApp.instance.sections.project.components.accessibleToCouncil.rebind();
        });

        return true;
    }

}